<template>
    <section id="booking" class="app">
        <div class="content-half text">
            <div class="signpost" v-if="bookingSectionInView">
                <h3>Lobsters - pre-order required</h3>
                <p>Please book in advance if you'd like these - they're sourced to order so let us know before 1pm on the day of dining, or even better mention it in your booking request.</p>
                <p>See the <a href="#menu" v-scroll-to="'#menu'" title="Link to menu section">menu</a> for which dishes require pre-order.</p>
            </div>
        </div><div class="content-half text">
        <h2>Book a table</h2>
        <p>We highly recommend booking a table - we have very limited seating and are the only dining option on the island.</p>



        <form v-on:submit.prevent="submitForm">
            <div class="styled-input wide">
                <input type="text" name="name" required />
                <label>Name</label>
            </div>
            <div class="styled-input wide">
                <input type="text" name="email" required />
                <label>Email</label>
            </div>
            <div class="styled-input wide">
                <input type="text" name="phone" required />
                <label>Phone</label>
            </div>
            <div class="styled-input wide">
                <input type="text" name="datetime" required />
                <label>Date and time</label>
            </div>
            <div class="styled-input wide">
                <textarea name="desc" required></textarea>
                <label>Party number, pre-orders and dietary requirements</label>
            </div>
            <input type="submit" class="btn-lrg button submit" name="action" value="Send Message" />
        </form>
    </div>
        <modal name="booking-success" :width="300" :height="250">
            <div class="modal">
                <p class="title">Thanks!</p>
                <p>Your booking request has been sent and we'll be in touch as soon as we can</p>
                <button @click="closeDialog()">Close</button>
            </div>

        </modal>
    </section>

</template>

<script>

    export default {
        name: 'Booking',

        data() {
            return {
                bookingSectionInView: false,
                bookingSectionOffset: 0
            }
        },
        methods: {
            submitForm: function (submitEvent) {

                var name = submitEvent.target.elements.name.value;
                var email = submitEvent.target.elements.email.value;
                var phone = submitEvent.target.elements.phone.value;
                var datetime = submitEvent.target.elements.datetime.value;
                var desc = submitEvent.target.elements.desc.value;

                this.ajaxRequest = true;
                this.$http.options.emulateJSON = true; // send as
                this.$http.post('https://bc2hjqq5w8.execute-api.eu-west-2.amazonaws.com/Prod/', {
                    name: name,
                    phone: phone,
                    email: email,
                    datetime: datetime,
                    desc: desc
                }, function (data, status, request) {
                    window.console.log(data);
                    window.console.log(status);
                    window.console.log(request);
                });
                this.ajaxRequest = false;
                this.$modal.show('booking-success');
                submitEvent.target.elements.name.value = '';
                submitEvent.target.elements.email.value = '';
                submitEvent.target.elements.phone.value = '';
                submitEvent.target.elements.datetime.value = '';
                submitEvent.target.elements.desc.value = '';
            },
            handleScroll: function() {
                this.bookingSectionOffset = document.getElementById('booking').offsetTop
                if (window.scrollY > this.bookingSectionOffset-100 && window.scrollY < this.bookingSectionOffset+400) {
                    this.bookingSectionInView = true;
                }
            },

            closeDialog: function() {
                this.$modal.hide('booking-success');
            },
        },
        mounted: function() {
            window.addEventListener("scroll", this.handleScroll);
        }

    }
</script>